
import Slider from 'react-slick';   
import  './PlatformPageSlide.css';


const PlatformPageSlide = ()=>{

 // START slick
const settings = {
  slidesToShow: 5,
  slidesToScroll: 1,
  margin: 30,
  autoplay: true,
  autoplaySpeed: 2000,
  loop: true,
  dots: false,
  arrows: false,
  focusOnSelect: true,
  centerPadding: '30px', 
  responsive: [
    {
      breakpoint: 1480,
      settings: {
        slidesToShow: 4, // Correcting the key to 'slidesToShow'
        infinite: true,
        centerPadding: "30px",
        margin: 30,
      },
    },
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 4, // Correcting the key to 'slidesToShow'
        infinite: true,
        centerPadding: "30px",
        margin: 30,
      },
    },
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3, // Correcting the key to 'slidesToShow'
        infinite: true,
        margin: 30,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3, // Correcting the key to 'slidesToShow'
        margin: 20,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1, // Correcting the key to 'slidesToShow'
        centerPadding: "30px",
      },
    },
  ],
};
// END slick

    return(
        <>
            {/* START platformPageSlideMain */}
            <section className="platformPageSlideMain">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="platformPageHead">
                                <h2>Built for businesses <br/>across any industry</h2>
                            </div>
                        </div>
                    </div>
                  </div>
                  
                  <div className='row justify-content-center'>
                    <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                        <Slider {...settings}> 
                            <div className="item">
                              <a href="/car-rental" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailBlack">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/car_1.svg" alt="Car Rental Agencies"/>
                                        </figure>
                                        <h3>Car Rental Agencies</h3>
                                        <p>Where rental operators come<br/> for a modern  rental experience</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transBlackBtn" href="/car-rental">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_white.svg" alt="Learn More"/>
                                        </a>
                                    </div>
                                </div>
                                </a>
                            </div>
                            <div className="item">
                              <a href="/car-sharing" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailWhite">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/refresh_1.svg" alt="Car Sharing Hosts"/>
                                        </figure>
                                        <h3>Car Sharing Hosts</h3>
                                        <p>The only direct & private <br/>rental platform for hosts</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transWhiteBtn" href="/car-sharing">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_black.svg" alt="Learn More"/>
                                        </a>
                                    </div>
                                </div>
                                </a>
                            </div>

                            <div className="item">
                              <a href="/ride-sharing" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailBlack">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/user_switch_1.svg" alt="Ride Share Drivers"/>
                                        </figure>
                                        <h3>Ride Share Drivers</h3>
                                        <p>Ride share rentals <br/>made really easy.</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transBlackBtn" href="/ride-sharing">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_white.svg" alt="Learn More"/>
                                        </a>
                                    </div>
                                </div>
                                </a>
                              </div>
                                                      
                            <div className="item">
                              <a href="/delivery" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailWhite">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/spoon_1.svg" alt="Delivery Drivers"/>
                                        </figure>
                                        <h3>Delivery Drivers</h3>
                                        <p>Expand your business by <br/>renting to gig delivery drivers</p>
                                    </div>
                                     <div className="platformPageBtn">
                                        <a className="btn transWhiteBtn" href="/delivery">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_black.svg" alt="Learn More"/>
                                        </a>
                                    </div>  
                                </div>
                              </a>
                          </div>

                          
                          <div className="item">
                              <a href="/auto-dealerships" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailBlack">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/parking_1.svg" alt="Auto Dealerships"/>
                                        </figure>
                                        <h3>Auto Dealerships</h3>
                                        <p>Dealership rental software <br/>for the modern customer</p>
                                    </div>
                                     <div className="platformPageBtn">
                                        <a className="btn transBlackBtn" href="/auto-dealerships">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_white.svg" alt="Learn More"/>
                                        </a>
                                    </div>  
                                </div>
                              </a>
                          </div>
                                                      
                          <div className="item">
                              <a href="/service-repair" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailWhite">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/wrench_1.svg" alt="Service & Repair"/>
                                        </figure>
                                        <h3>Service & Repair</h3>
                                        <p>Loaner Cars & Rentals for <br/>Auto Service & Repair Facilities</p>
                                    </div>
                                     <div className="platformPageBtn">
                                        <a className="btn transWhiteBtn" href="/service-repair">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_black.svg" alt="Learn More"/>
                                        </a>
                                    </div> 
                                </div>
                              </a>
                          </div>

                          <div className="item">
                              <a href="/vacation-rental" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailBlack">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/house_1.svg" alt="Home Rental Hosts"/>
                                        </figure>
                                        <h3>Home Rental Hosts</h3>
                                        <p>Turn Your Rental Home into <br/>the Ultimate Travel Experience</p>
                                    </div>
                                     <div className="platformPageBtn">
                                        <a className="btn transBlackBtn" href="/vacation-rental">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_white.svg" alt="Learn More"/>
                                        </a>
                                    </div> 
                                </div>
                              </a>
                          </div>
                                                      
                          <div className="item">
                              <a href="/hotel-resort" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailWhite">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/hotel_1.svg" alt="Hotel & Resort"/>
                                        </figure>
                                        <h3>Hotel & Resort</h3>
                                        <p>Elevate Your Guest Experience with Seamless Car Rentals</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transWhiteBtn" href="/hotel-resort">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_black.svg" alt="Learn More"/>
                                        </a>
                                    </div> 
                                </div>
                              </a>
                          </div>

                        <div className="item">
                            <a href="/property-management" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailBlack">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/property_1.svg" alt="Property Mgmt"/>
                                        </figure>
                                        <h3>Property Mgmt</h3>
                                        <p>Turn your properties into <br/>profit with built-in car rentals.</p>
                                    </div>
                                     <div className="platformPageBtn">
                                        <a className="btn transBlackBtn" href="/property-management">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_white.svg" alt="Learn More"/>
                                        </a>
                                    </div> 
                                </div>
                              </a>
                        </div>
                                                    
                        <div className="item">
                            <a href="/corporate" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailWhite">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/briefcase_1.svg" alt="Corporate"/>
                                        </figure>
                                        <h3>Corporate</h3>
                                        <p>Corporate Rental Fleet <br/>Services Made Easy</p>
                                    </div>
                                     <div className="platformPageBtn">
                                        <a className="btn transWhiteBtn" href="/corporate">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_black.svg" alt="Learn More"/>
                                        </a>
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div className="item">
                            <a href="/government" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailBlack">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/pentagon_1.svg" alt="Government"/>
                                        </figure>
                                        <h3>Government</h3>
                                        <p>Fleet Rentals for <br/>Government & Municipal</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transBlackBtn" href="/government">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_white.svg" alt="Learn More"/>
                                        </a>
                                    </div> 
                                </div>
                            </a>
                        </div>
                        <div className="item">
                            <a href="/education" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailWhite">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/education_1.svg" alt="education"/>
                                        </figure>
                                        <h3>Education</h3>
                                        <p>Empowering mobility for students,<br/> staff, and institutions.</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transWhiteBtn" href="/education">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_black.svg" alt="Learn More"/>
                                        </a>
                                    </div>
                                </div>
                            </a>
                        </div>

                        </Slider> 
      
                    </div>
                </div>  
            </section>
            {/* END platformPageSlideMain */}
        </>
    )
}

export default PlatformPageSlide;